import * as dateFns from "date-fns";

/**
 * Round time to nearest x minutes
 * From: https://github.com/date-fns/date-fns/issues/787#issuecomment-405834116
 * @param date Date to round
 * @param interval Minutes to round to
 * @returns New date, after rounding
 */
export const roundToNearestMinutes = (date: Date, interval: number): Date => {
  const roundedMinutes = Math.floor(dateFns.getMinutes(date) / interval) * interval;
  return dateFns.setMinutes(dateFns.startOfMinute(date), roundedMinutes);
};
